import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { installProtocolMismatchReload } from "./protocol-compatibility";
import "./styles.css";
import "./chat-appearance.css";

installProtocolMismatchReload(window, () => window.location.reload());

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
